import { render, staticRenderFns } from "./LayoutPaginable.vue?vue&type=template&id=4888eba1&"
import script from "./LayoutPaginable.vue?vue&type=script&lang=ts&"
export * from "./LayoutPaginable.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutPaginable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
